/**
 * Returns the translated string, or a sensible fallback when the key is missing from the API.
 * When no translation exists, `t()` returns the key unchanged — we substitute the fallback instead.
 */
export function translateWithFallback(
    t: (key: string, params?: Record<string, unknown>) => string,
    key: string,
    fallback: string,
    params?: Record<string, unknown>
): string {
    const translated = t(key, params);
    return translated === key ? fallback : translated;
}